import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'
import './styles.less'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../utils/loading'
import { getAllAttachments } from '../../redux/actions/attachments'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import AttachFilesDocWidget from '../../widgets/attachfiles/AttachFilesDocWidget'
import InfomaFilesWidget from '../../widgets/infomaWidget/InfomaFilesWidget'
import InfomaFilesOldWidget from '../../widgets/infomaWidget/InfomaFilesOldWidget'

export default function AttachFilesAllView() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getAllAttachments(projectId)

      //ปรับ schema approve
      if (_schema?.forms?.approve && _schema?.forms?.approve?.fileLists?.values?.length > 0) {
        _schema?.forms?.approve?.fileLists?.values.map((item, index) => {
          const fileType = item.fileName.split('.')[1]
          if (fileType == 'docx') {
            // console.log('item.path ', item.path)
            const fpath = item.path.replace('${projectVersionId}', projectId)
            const apath = fpath.replace('/api', '')
            // console.log('a path ', apath)
            const bpath = apath.replace('/report/', '/files/')
            // console.log('b path ', bpath)
            _schema.forms.approve.fileLists.values[index].path = bpath
            _schema.forms.approve.fileLists.values[index].type = fileType
          }
        })
      }

      setSchema(_schema)

      // setSchema(mock)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    // console.log('load AttachFilesAllWidget projectId', projectId)
    handleGetSchema()
  }, [])

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal statusDefault={1}>
        <ContentHeader header={schema.header} subHeader={schema.subHeader} />

        {schema?.forms?.proposal && (
          <>
            <AttachFilesDocWidget schema={schema.forms.proposal} canReload reloadId={[projectId]} />
            <br />
          </>
        )}

        {schema?.forms?.review && (
          <>
            <AttachFilesDocWidget schema={schema.forms.review} />
            <br />
          </>
        )}

        {schema?.forms?.approve && (
          <>
            <AttachFilesDocWidget schema={schema.forms.approve} />
            <br />
          </>
        )}

        {schema?.forms?.contract && (
          <>
            <AttachFilesDocWidget schema={schema.forms.contract} />
            <br />
          </>
        )}

        {schema?.forms?.contractChange && (
          <>
            <AttachFilesDocWidget schema={schema.forms.contractChange} />
            <br />
          </>
        )}

        {schema?.forms?.infoma && (
          <>
            {/* <AttachFilesDocWidget schema={schema.forms.infoma} infoma={true} /> */}

            <InfomaFilesOldWidget projectId={projectId} />
            <br />
          </>
        )}

        {schema?.forms?.infomaNew && (
          <>
            <InfomaFilesWidget projectId={projectId} />
            <br />
          </>
        )}

        {schema?.forms?.executeClose && (
          <>
            <AttachFilesDocWidget schema={schema.forms.executeClose} />
            <br />
          </>
        )}
      </SidebarProposal>
    </>
  )
}
